export function createCommandId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = [...bytes].map((value) => value.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export function createIdempotencyKey(scope) {
  return `${String(scope || 'command').replace(/[^a-z0-9._-]/gi, '-').toLowerCase()}:${createCommandId()}`;
}

export function commandEnvelope(scope) {
  return { command_id: createCommandId(), idempotency_key: createIdempotencyKey(scope) };
}

export const createUuid = createCommandId;

export function saveCommandEnvelope(scope, intent, item) {
  const commandIntent = String(intent || '').toLowerCase();
  if (!['create', 'update'].includes(commandIntent)) throw new TypeError('Save intent must be create or update');
  if (!item || typeof item !== 'object' || Array.isArray(item)) throw new TypeError('Save item must be an object');
  const payloadItem = { ...item };
  const version = Number(payloadItem.version || 0);
  delete payloadItem.version;
  delete payloadItem.command_id;
  delete payloadItem.idempotency_key;
  delete payloadItem.command_intent;
  delete payloadItem.expected_revision;
  if (commandIntent === 'create') {
    payloadItem.id = 0;
  } else {
    if (!Number.isInteger(Number(payloadItem.id)) || Number(payloadItem.id) <= 0) throw new TypeError('Update requires a positive record id');
    if (!Number.isInteger(version) || version <= 0) throw new TypeError('Update requires a positive record version');
  }
  return {
    ...commandEnvelope(scope),
    command_intent: commandIntent,
    expected_revision: commandIntent === 'update' ? version : 0,
    item: payloadItem,
  };
}
